<template>
  <li class="list-group-item">
    <div class="float-left" style="padding: 6px">
      <h5 href="#">
        <b
          :class="hasObservation(clas.id)"
          v-if="hasObservation(clas.id) == 'observation'"
          class="lesson-name"
          >{{ clas.name }} <i class="el-icon-warning-outline"></i>
        </b>
        <b v-else class="lesson-name" :class="hasObservation(clas.id)">{{ clas.name }} </b>
      </h5>
    </div>

    <div class="float-right">
      <button class="btn btn-link" @click="editClass(clas)">Editar</button>
      <button class="btn btn-link" @click="deleteClass(clas)">Eliminar</button>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    module: {
      type: Object,
      required: true,
    },
    clas: {
      type: Object,
      required: true,
    },
    observations: {
      type: Array,
      required: true,
    },
  },
  methods: {
    editClass(classSelected) {
      this.$emit('editClass', classSelected);
    },

    deleteClass(classSelected) {
      this.$emit('deleteClass', classSelected);
      console.log(classSelected);
    },

    hasObservation(class_id) {
      let result = this.observations.map((observation) => observation.id_class);
      if (result.includes(class_id)) {
        return 'observation';
      } else {
        return false;
      }
    },
  },
};
</script>

<style>
.observation {
  color: #ff9f43;
}
.lesson-name {
  text-transform: capitalize;
}
</style>
